var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import { IconButton } from '@mui/material';
import { shippingInstruction as api } from '../../../api';
import { useRequest } from '../../../hooks/requestHook';
import useDownload from '../../../hooks/useDownload';
import DownloadIconWithText from '../../atoms/DownloadIconWithtext';
import PageLayout from '../../atoms/PageLayout';
import ShippingInstructionForm from './ShippingInstructionForm';
import ShippingInstructionItemsTable from './ShippingInstructionItemsTable';
var ActionWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-wrap: wrap;\n\n  .MuiIconButton-root {\n    .MuiTypography-root {\n      font-size: 9px;\n    }\n\n    svg {\n      font-size: 32px;\n    }\n  }\n"], ["\n  display: flex;\n  flex-wrap: wrap;\n\n  .MuiIconButton-root {\n    .MuiTypography-root {\n      font-size: 9px;\n    }\n\n    svg {\n      font-size: 32px;\n    }\n  }\n"])));
var AdminShippingInstructionDetailPage = function () {
    var _a = useParams().id, id = _a === void 0 ? '' : _a;
    var _b = React.useState(), shippingInstruction = _b[0], setShippingInstruction = _b[1];
    var getApi = useRequest(api.get);
    var shippingInstructionDownload = useDownload({
        path: "/api/shipping_instructions/".concat(id, ".pdf"),
        downloadFilename: "shipping_instruction_#".concat(id, ".pdf"),
    });
    var commercialInvoiceDownload = useDownload({
        path: "/api/shipping_instructions/".concat(id, "/commercial_invoice.pdf"),
        downloadFilename: "commercial_invoice_#".concat(id, ".pdf"),
    });
    var packingListDownload = useDownload({
        path: "/api/shipping_instructions/".concat(id, "/packing_list.pdf"),
        downloadFilename: "packing_list_#".concat(id, ".pdf"),
    });
    React.useEffect(function () {
        var canceled = false;
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getApi(id)];
                    case 1:
                        response = _a.sent();
                        if (!response || canceled)
                            return [2 /*return*/];
                        setShippingInstruction(__assign(__assign({}, response), { items: response.items.map(toEditableItem) }));
                        return [2 /*return*/];
                }
            });
        }); })();
        return function () {
            canceled = true;
        };
    }, [id, getApi]);
    var handleChange = React.useCallback(function (nextShippingInstruction) {
        if (!shippingInstruction)
            return;
        setShippingInstruction(__assign(__assign({}, nextShippingInstruction), { items: nextShippingInstruction.items.map(toEditableItem) }));
    }, [shippingInstruction]);
    var handleUpdateItem = React.useCallback(function (item) {
        if (!shippingInstruction)
            return;
        var updateItem = toEditableItem(item);
        var items = shippingInstruction === null || shippingInstruction === void 0 ? void 0 : shippingInstruction.items.map(function (i) {
            return i.id === updateItem.id ? updateItem : i;
        });
        setShippingInstruction(__assign(__assign({}, shippingInstruction), { items: items }));
    }, [shippingInstruction]);
    var handleCreateItem = React.useCallback(function (item) {
        if (!shippingInstruction)
            return;
        setShippingInstruction(__assign(__assign({}, shippingInstruction), { items: __spreadArray(__spreadArray([], shippingInstruction.items, true), [toEditableItem(item)], false) }));
    }, [shippingInstruction]);
    var handleDeleteItem = React.useCallback(function (item) {
        if (!shippingInstruction)
            return;
        setShippingInstruction(__assign(__assign({}, shippingInstruction), { items: shippingInstruction.items.filter(function (i) { return i.id !== item.id; }) }));
    }, [shippingInstruction]);
    var editable = React.useMemo(function () { return (shippingInstruction === null || shippingInstruction === void 0 ? void 0 : shippingInstruction.status) === 'draft'; }, [shippingInstruction]);
    var warehouseName = React.useMemo(function () { return (shippingInstruction === null || shippingInstruction === void 0 ? void 0 : shippingInstruction.warehouseName) || ''; }, [shippingInstruction]);
    return (React.createElement(PageLayout, { backLink: true, title: "Shipping instruction / Commercial invoice / Packing list #".concat(id, " on ").concat(warehouseName), actions: React.createElement(ActionWrapper, null,
            React.createElement(IconButton, { onClick: shippingInstructionDownload.handleDownload, disabled: shippingInstructionDownload.downloading },
                React.createElement(DownloadIconWithText, { title: "Shipping Instruction" })),
            React.createElement(IconButton, { onClick: commercialInvoiceDownload.handleDownload, disabled: commercialInvoiceDownload.downloading },
                React.createElement(DownloadIconWithText, { title: "Commercial Invoice" })),
            React.createElement(IconButton, { onClick: packingListDownload.handleDownload, disabled: packingListDownload.downloading },
                React.createElement(DownloadIconWithText, { title: "Packing List" }))) }, shippingInstruction && (React.createElement(React.Fragment, null,
        React.createElement(ShippingInstructionForm, { editable: editable, shippingInstruction: shippingInstruction, onChange: handleChange }),
        React.createElement(ShippingInstructionItemsTable, { editable: editable, shippingInstruction: shippingInstruction, items: shippingInstruction.items, onCreated: handleCreateItem, onUpdated: handleUpdateItem, onDeleted: handleDeleteItem })))));
};
export default AdminShippingInstructionDetailPage;
// 不要なデータを落とす
var toEditableItem = function (item) { return ({
    id: item.id,
    lotNumber: item.lotNumber,
    lotRef: item.lotRef,
    productName: item.productName,
    bagSize: item.bagSize,
    quantity: item.quantity,
    netWeight: item.netWeight,
    fobPrice: item.fobPrice,
    package: item.package,
    totalPrice: item.totalPrice,
}); };
var templateObject_1;
